import { ready } from 'shared/ready'

class ExampleTextContent {
  constructor() {
    this.$entireCVCopy = document.getElementById('entire_profile_copy')

    this.$entireCVCopy &&
      this.$entireCVCopy.addEventListener('click', () => {
        copyTextFromSection(
          '#text-format_example_entire_cv .text-format_example__section_container',
        )
      })
  }
}

// Function to copy text from a specific section
async function copyTextFromSection(sectionSelector) {
  // Get the section element
  const sections = document.querySelectorAll(sectionSelector)
  if (!sections || sections.length === 0) return

  // Get the text content from that section
  const textToCopy = Array.from(sections)
    .map(section => section.innerText)
    .join('\n\n')

  // Use the navigator clipboard API to copy the text
  await navigator.clipboard.writeText(textToCopy)
}

ready(function () {
  new ExampleTextContent()
})
